// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__2X5Sk"};